<template>
  <div>
    <label :class="labelClass" class="form-label" for="prices_to_select">
      Precio hasta
    </label>
    <v-select
      v-model="filter"
      :reduce="(prices) => prices.value"
      :options="getPrices()"
      placeholder="Seleccionar"
      label="name"
      class="form-input-filter"
      name="prices"
      id="prices_to_select"
    >
      <span slot="no-options">Sin resultados</span>
    </v-select>
  </div>
</template>
<script>
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
Vue.component("v-select", vSelect);
export default {
  props: ["labelClass", "price"],

  data: () => ({
    filter: null,
  }),

  watch: {
    price: {
      handler(newValue) {
        this.filter = newValue;
      },
    },
    filter: {
      handler(newValue) {
        let vm = this;
        if (!!document.getElementById("price_to")) {
          document.getElementById("price_to").value = newValue;
        }
        this.$emit("price", newValue);
      },
    },
  },

  methods: {
    getPrices() {
      let data = [
        {
          title: "$100,000",
          id: 100000,
        },
        {
          title: "$200,000",
          id: 200000,
        },
        {
          title: "$300,000",
          id: 300000,
        },
        {
          title: "$400,000",
          id: 400000,
        },
        {
          title: "$500,000",
          id: 500000,
        },
        {
          title: "$600,000",
          id: 600000,
        },
        {
          title: "$700,000",
          id: 700000,
        },
        {
          title: "$800,000",
          id: 800000,
        },
        {
          title: "$900,000",
          id: 900000,
        },
        {
          title: "$1,000,000",
          id: 1000000,
        },
        {
          title: "$1,000,000 o más",
          id: 1000001,
        },
      ];
      return _.map(data, function (item, key) {
        return {
          name: item.title,
          value: item.id,
        };
      });
    },
  },
};
</script>
